<template>
  <div id="app">
    <section id="loadingTxt">
      <span style="color:#F55246">Just a moment, please...</span>
    </section>
    <v-app>
      <AppBar />
      <v-main>
        <router-view />
      </v-main>
      <AppFooter />
    </v-app>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
    AppBar: () => import( /* webpackChunkName: "AppBar" */ './components/AppBar.vue'),
    AppFooter: () => import( /* webpackChunkName: "AppFooter" */ './components/AppFooter.vue')
  },
  mounted() {
    window.addEventListener('load', () => {
      // run after everything is in-place
      var lt = document.getElementById('loadingTxt');
      lt.remove();
      var ai = document.getElementById('appInit');
      ai.remove();
      //console.log('[my-component] is mounted at element:', this.$el);
      //console.log('this is mounted at element:', this.$el.parentNode);
      document.head || (document.head = document.getElementsByTagName('head')[0]);
      var lsLink = document.getElementById('loadingStyle');
      if (lsLink) {
        document.head.removeChild(lsLink);//remove stylesheet
      }
    })
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/*html,
body {
  overflow-x: visible;
  overflow-y: visible;
}*/

</style>